import { AccountConfigNonStandardProperties } from "./reducers/environments";

/**
 * KEEP THESE SORTED ALPHABETICALLY.
 */
type FeatureFlag =
  | "adBlock"
  | "adPerformanceMeta"
  | "allowJsDynamicProp"
  | "analytics"
  | "appointmentStageMapping"
  | "audienceEmailFromUserProperty"
  | "audiencePerformanceUI"
  | "audienceSegmentationUserProperties"
  | "audiences"
  | "audiencesIngest"
  | "botBlocking"
  | "cdaDashboard"
  | "chatSupport"
  | "claudeOrchestrator"
  | "contractAllowsAIUsage"
  | "darkMode"
  | "dataConnectors"
  | "dataSharingAgreement"
  | "disableMasqueradeWarningBanner"
  | "destinationValidationChat"
  | "displayNewEventLibraryPage"
  | "emitAppointmentAttributionEvents"
  | "emitAppointmentAttributionEventsMeta"
  | "emitConsentDeniedConversionEvents"
  | "emitFPUnattributableConversionEvents"
  | "emitNonFPUnattributableConversionEvents"
  | "eventIdentitySupport"
  | "fpAiProactiveCards"
  | "freshpaintAiAttachments"
  | "freshpaintAiChat"
  | "freshpaintAiDev"
  | "freshpaintConsentManagementUI"
  | "frictionSignals"
  | "functions"
  | "generalEnvironmentSettings"
  | "googleAdsEnhancedConversionsPassthrough"
  | "googleDataManagerConversionApi"
  | "groupByBusinessDimension"
  | "hipaaV2"
  | "homepageAndOnboarding"
  | "identityMatching"
  | "identityMergeSimulator"
  | "insightsSeasonality"
  | "marketingPerformanceAnalysis"
  | "networkEventDefs"
  | "pharmaPdfReport"
  | "phoneNumberAudiences"
  | "podscribe"
  | "precisionEventsDefaultNotSegmentCompatible"
  | "rbac"
  | "selfServeAuditLog"
  | "serviceAccounts"
  | "sessionReplayCardViewEnabled"
  | "sessionReplayHideLowEngagement"
  | "sessionReplayRecordingPaused"
  | "sourceFunctions"
  | "sqlTransformations"
  | "sqlTransformationsv2"
  | "tempAudiencesNoOverview"
  | "profileUploadAABridge"
  | "tempFunnelCoreProcedure"
  | "tempNewUploader"
  | "tempSegmentsDetailV2"
  | "tempSegmentsM1"
  | "traces"
  | "trafficFilters"
  | "translation"
  | "unifiedDestinationsUI"
  | "useUnifiedEntryScript"
  | "webTrackerMonitoring"
  | "webTrackerMonitoringGatekeeper"
  | "webTrackerMonitoringM3"
  | "webTrackerMonitoringTrackerBlockedUI"
  | "webTrackerMonitoringWtm2";

export type FlagGetter = (featureName: FeatureFlag) => boolean;

/**
 * Get the value of a feature flag
 */
interface FeatureFlagConfigurationLocation {
  config: Partial<
    Record<FeatureFlag, boolean> & AccountConfigNonStandardProperties
  >;
}
export function getFeature(
  accountMetadata: FeatureFlagConfigurationLocation,
  featureFlag: FeatureFlag,
): boolean {
  switch (featureFlag) {
    case "adBlock":
    case "adPerformanceMeta":
    case "allowJsDynamicProp":
    case "analytics":
    case "appointmentStageMapping":
    case "audiences":
    case "audiencesIngest":
    case "audienceEmailFromUserProperty":
    case "audiencePerformanceUI":
    case "audienceSegmentationUserProperties":
    case "botBlocking":
    case "cdaDashboard":
    case "chatSupport":
    case "claudeOrchestrator":
    case "contractAllowsAIUsage":
    case "darkMode":
    case "dataConnectors":
    case "dataSharingAgreement":
    case "disableMasqueradeWarningBanner":
    case "destinationValidationChat":
    case "displayNewEventLibraryPage":
    case "emitAppointmentAttributionEvents":
    case "emitAppointmentAttributionEventsMeta":
    case "emitConsentDeniedConversionEvents":
    case "emitFPUnattributableConversionEvents":
    case "emitNonFPUnattributableConversionEvents":
    case "fpAiProactiveCards":
    case "freshpaintAiAttachments":
    case "freshpaintAiChat":
    case "freshpaintAiDev":
    case "freshpaintConsentManagementUI":
    case "frictionSignals":
    case "functions":
    case "generalEnvironmentSettings":
    case "googleAdsEnhancedConversionsPassthrough":
    case "googleDataManagerConversionApi":
    case "groupByBusinessDimension":
    case "hipaaV2":
    case "homepageAndOnboarding":
    case "identityMatching":
    case "identityMergeSimulator":
    case "insightsSeasonality":
    case "marketingPerformanceAnalysis":
    case "eventIdentitySupport":
    case "networkEventDefs":
    case "pharmaPdfReport":
    case "phoneNumberAudiences":
    case "podscribe":
    case "precisionEventsDefaultNotSegmentCompatible":
    case "rbac":
    case "selfServeAuditLog":
    case "serviceAccounts":
    case "sessionReplayCardViewEnabled":
    case "sessionReplayHideLowEngagement":
    case "sessionReplayRecordingPaused":
    case "sourceFunctions":
    case "sqlTransformations":
    case "sqlTransformationsv2":
    case "tempAudiencesNoOverview":
    case "profileUploadAABridge":
    case "tempFunnelCoreProcedure":
    case "tempNewUploader":
    case "tempSegmentsDetailV2":
    case "tempSegmentsM1":
    case "traces":
    case "trafficFilters":
    case "translation":
    case "unifiedDestinationsUI":
    case "useUnifiedEntryScript":
    case "webTrackerMonitoring":
    case "webTrackerMonitoringM3":
    case "webTrackerMonitoringTrackerBlockedUI":
    case "webTrackerMonitoringGatekeeper":
    case "webTrackerMonitoringWtm2":
      return accountMetadata.config[featureFlag] || false;
    default:
      console.warn("Unsupported feature %s requested", featureFlag);
      return false;
  }
}

export default FeatureFlag;
